<template>
  <div>
    <InteractionHint v-if="!readonly">
      Выберите правильный вариант
    </InteractionHint>
    <v-radio-group :value="value" @change="answer" :disabled="readonly">
      <v-radio
        v-for="(item, index) in optionsList"
        :key="index"
        class="answer my-2"
        :label="item.index + ' ' + item.option"
        :value="String(index + 1)"
      />
    </v-radio-group>
  </div>
</template>
<script type="text/babel">
import InteractionHint from './InteractionHint'
export default {
  name: 'Interaction1OfN',
  components: {
    InteractionHint
  },
  props: {
    items: {
      type: [Array, Object],
      required: true
    },
    value: {
      required: true
    },
    readonly: {
      default: false
    }
  },
  computed: {
    optionsList() {
      if (Array.isArray(this.items)) {
        return this.items.map((e, index) => {
          const c = { ...e }
          c.checked = index + 1 === this.value
          return c
        })
      } else {
        return []
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', this.keyDown)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keyDown)
  },
  methods: {
    keyDown(event) {
      switch (event.code) {
        case 'Digit1':
        case 'Digit2':
        case 'Digit3':
        case 'Digit4':
        case 'Digit5':
        case 'Digit6':
        case 'Digit7':
        case 'Digit8':
        case 'Digit9':
          this.answer(event.code.slice(-1))
          break
        default:
          this.answer('')
          break
      }
    },
    answer(value) {
      this.$emit('input', value)
    }
  }
}
</script>
